import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import OrderDashboardIcon from '../../OrderDashboard/atoms/Icon';

class Icon extends React.Component {
  render() {
    return <OrderDashboardIcon {...this.props} />;
  }
}

Icon.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles()(Icon);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/atoms/Icon.jsx